import { ChevronLeft, ChevronRight, Check, Loader2 } from 'lucide-react';
import { Button } from '../Button';

interface WizardNavigationProps {
  currentStep: number;
  totalSteps: number;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  canGoNext: boolean;
  isSubmitting?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
  prevLabel?: string;
  nextLabel?: string;
}

export function WizardNavigation({
  currentStep,
  totalSteps,
  onPrev,
  onNext,
  onSubmit,
  onCancel,
  canGoNext,
  isSubmitting = false,
  submitLabel = 'Guardar',
  cancelLabel = 'Cancelar',
  prevLabel = 'Anterior',
  nextLabel = 'Siguiente',
}: WizardNavigationProps) {
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;

  return (
    <div className="flex justify-between pt-6 border-t border-gray-200 dark:border-gray-700">
      <div className="flex gap-3">
        <Button variant="outline" onClick={onCancel} disabled={isSubmitting}>
          {cancelLabel}
        </Button>
        {!isFirstStep && (
          <Button
            variant="outline"
            onClick={onPrev}
            disabled={isSubmitting}
            leftIcon={<ChevronLeft className="w-4 h-4" />}
          >
            {prevLabel}
          </Button>
        )}
      </div>

      <div>
        {isLastStep ? (
          <Button
            onClick={onSubmit}
            disabled={!canGoNext || isSubmitting}
            leftIcon={isSubmitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
          >
            {submitLabel}
          </Button>
        ) : (
          <Button
            onClick={onNext}
            disabled={!canGoNext}
            rightIcon={<ChevronRight className="w-4 h-4" />}
          >
            {nextLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
